"use client"
import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import LoadingSpinner from "./LoadingSpinner"

export default function AdminAnyRoute({ children }) {
  const { loading, currentRole } = useAuth()
  const location = useLocation()

  if (loading) return <LoadingSpinner message="Cargando..." />

  const role = String(currentRole || "").toLowerCase().trim()

  const isGlobalAdminActive = ["administrador", "admin", "superadmin"].includes(role)
  const isFacultyAdminActive = ["admin_facultad", "coordinador_facultad"].includes(role)

  const allowed = isGlobalAdminActive || isFacultyAdminActive

  if (!allowed) {
    // ✅ si quieres mostrar mensaje en Home, lo mandamos por state
    return (
      <Navigate
        to="/"
        replace
        state={{
          denied: true,
          reason: "NO_ADMIN_ROLE",
          from: location.pathname
        }}
      />
    )
  }

  return children
}